







import { Component, Prop, Vue } from 'vue-property-decorator';
import ArrowIcon from '@/assets/icons/arrow.svg';

@Component({
    components: {
        ArrowIcon,
    },
})
export default class TextualIcon extends Vue {
    @Prop({ type: String, required: true })
    private label!: string;

    @Prop({ type: Boolean, required: false, default: false })
    private inverted!: boolean;
}
